import { useMemo } from 'react';
import React from 'react';
import { Notification, NotificationPriority, NotificationStatusColorType } from '@common-fe/common-fe';
import dayjs from 'dayjs';
import _ from 'lodash';

import { FULL_DATE_TIME_FORMATE } from '@/common/constants';
import REGEXP from '@/common/regexp';

import { RawNotification } from '../notification.types';

const DATE_PREFIX = 'date_';
const BR_TAG_REGEXP = /{{#br}}/g;
const IF_TAG_REGEXP = /{{#if (\w+)}}([\s\S]*?){{\/if}}/g;
const NONE_VALUE = 'none';
export default (notifications: RawNotification[]) => {
  const formattedNotifications = useMemo(
    () =>
      notifications.map((item) => {
        let status = NotificationStatusColorType.DEFAULT;
        if (item.priority === NotificationPriority.Important) {
          status = NotificationStatusColorType.ERROR;
        } else if (item.priority === NotificationPriority.Info) {
          status = NotificationStatusColorType.SUCCESS;
        } else if (item.priority === NotificationPriority.NeedHelp) {
          status = NotificationStatusColorType.WARNING;
        }

        let { title, page } = item;
        const { description } = item;
        let additionalDescription: string | React.ReactNode = description || '';
        if (item.templateVariablesValues) {
          const replaceTemplateString = (field?: string) => {
            if (!field) return '';

            let result = field;

            // First handle `{{#if key}}...{{/if}}`
            result = result.replace(IF_TAG_REGEXP, (match, key, content) => {
              const value = _.get(item.templateVariablesValues, key);
              return value ? content : '';
            });

            // Line break
            result = result.replace(BR_TAG_REGEXP, '\n\n');

            // Then handle `{{key}}` replacement
            // @ts-ignore
            result = result.replace(/{{(\w+)}}/g, (match, key) => {
              const value = _.get(item.templateVariablesValues, key, '');

              if (key.includes(DATE_PREFIX) && field.includes(DATE_PREFIX)) {
                const date = dayjs(value as string);
                return date.isValid() ? date.format(FULL_DATE_TIME_FORMATE) : value;
              }

              return value;
            });

            return result;
          };

          title = replaceTemplateString(title);
          page = replaceTemplateString(page);
          additionalDescription = replaceTemplateString(description);
        }
        page = page ? page.replace(REGEXP.INSIDE_CURLED_DOUBLE_BRAKETS, NONE_VALUE) : page;

        return {
          id: `${item.id}`,
          createdAt: dayjs(item.createdAt).toDate(),
          text: title,
          additionalText: additionalDescription,
          time: '',
          status,
          notificationStatus: item.status,
          page,
        } as Notification;
      }),
    [notifications]
  );

  return formattedNotifications;
};
